/**
 * Explore Products Tabs Component
 * Handles tab switching functionality for the Explore Products section
 */

class ExploreProductsTabs extends HTMLElement {
  constructor() {
    super();
    
    this.tabButtons = this.querySelectorAll('.tab-button');
    this.tabContents = this.querySelectorAll('.tab-content');
    this.sectionId = this.dataset.sectionId;
    
    this.init();
  }

  init() {
    // Add click event listeners to all tab buttons
    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  /**
   * Handle tab button click
   * @param {Event} event - The click event
   */
  handleTabClick(event) {
    const clickedButton = /** @type {HTMLElement} */ (event.currentTarget);
    if (!clickedButton) return;
    
    const tabId = clickedButton.dataset.tabId;
    if (!tabId) return;

    // If the clicked tab is already active, do nothing
    if (clickedButton.classList.contains('active')) {
      return;
    }

    // Remove active class from all buttons
    this.tabButtons.forEach(btn => {
      btn.classList.remove('active');
    });

    // Add active class to clicked button
    clickedButton.classList.add('active');

    // Hide all tab contents
    this.tabContents.forEach(content => {
      content.classList.remove('active');
    });

    // Show the corresponding tab content
    const targetContent = this.querySelector(`.tab-content[data-tab-id="${tabId}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }
}

// Register the custom element
if (!customElements.get('explore-products-tabs')) {
  customElements.define('explore-products-tabs', ExploreProductsTabs);
}
